import React, { useState } from 'react';
import './LoginPage.css';
import { useNavigate } from 'react-router';
import { useAuth } from '../../context/AuthContext';

function LoginPage() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { isLoggedIn, userRole, login, logout } = useAuth();

  const handleLogin = async () => {
    const requestBody = { email, password };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/tkn/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        const data = await response.json();
        login(data.token, data);
        navigate('/');  // Navigate to the home page or update the app state
      } else {
        const errorData = await response.json();
        setError('Login failed');
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="quote-container">
          <h4>LAKI</h4>
          <h1>Money Market Funds</h1>
          {/* <p>You can get everything you want if you work hard, trust the process, and stick to the plan.</p> */}
        </div>
      </div>
      <div className="login-right">
        <div className="login-form-container">
          <img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="Logo" className="logo"/>
          <h2>Welcome Back</h2>
          <p>Enter your email and password to access your account</p>
          {error && <p className="error-login">{error}</p>}
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="options">
            <label>
              <input type="checkbox" /> Remember me
            </label>
            <a href="/">Forgot Password</a>
          </div>
          <button onClick={handleLogin} className="sign-in-btn">Sign In</button>
          {/* <button className="google-sign-in-btn">Sign In with Google</button> */}
          <p>
            Don’t have an account? <a href="/signup">Sign Up</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;

